import { type ReactElement } from 'react';

import { ChatComposer } from '@/shared/chat/chat-composer.js';

export interface WhatsAppInboxComposerProps {
  readonly draft: string;
  readonly disabled: boolean;
  readonly isSending: boolean;
  readonly isUploading: boolean;
  readonly errorMessage: string | null;
  readonly onError: (message: string) => void;
  readonly onDraftChange: (value: string) => void;
  readonly onSubmitText: () => void;
  readonly onSubmitAudio: (file: File) => Promise<boolean>;
  readonly onAttachFile: (file: File) => void;
}

export function WhatsAppInboxComposer({
  onSubmitAudio,
  ...props
}: WhatsAppInboxComposerProps): ReactElement {
  return (
    <ChatComposer
      {...props}
      photoAccept="image/*,video/*,.mp4,.mov,.webm,.mkv,.3gp"
      fileInputClassName="whatsapp-inbox-composer__file-input"
      onSubmitAudio={async (file) => onSubmitAudio(file)}
    />
  );
}
